import { useState, useEffect } from "react";
import deliveryService from "../../../services/delivery.service";

const ERROR_RUTA = "Error al obtener la ruta de mostrador";
const ERROR_TRANSPORTISTA = "No se pudo resolver el transportista de la ruta de mostrador";

const ESTADO_INICIAL = { rutaMostrador: null, transportista: null, cargando: true, error: null };

// Como en el legacy: una respuesta vacía o que no es un objeto significa "sin ruta"
const hayRuta = (respuesta) =>
    Boolean(respuesta) && typeof respuesta === "object" && Object.keys(respuesta).length > 0;

const cargarTransportista = async (ruta) => {
    try {
        const transportistas = await deliveryService.getTransports();
        const encontrado = transportistas.find((t) => t.CODIGO === ruta.transportista);
        return { transportista: encontrado || null, error: null };
    } catch (err) {
        console.error("Error cargando transportistas:", err);
        return { transportista: null, error: ERROR_TRANSPORTISTA };
    }
};

/**
 * Hook que carga una sola vez la ruta de mostrador y resuelve su transportista.
 * No genera toasts: la página decide cómo avisar. `rutaMostrador` null solo
 * significa "no existe" cuando `cargando` es false.
 * @returns {{
 *   rutaMostrador: Object|null,
 *   transportista: Object|null,
 *   cargando: boolean,
 *   error: string|null
 * }} Ruta, transportista (null si no se resolvió), estado de carga y error (no bloqueante si hay ruta)
 */
export const useRutaMostrador = () => {
    const [estado, setEstado] = useState(ESTADO_INICIAL);

    useEffect(() => {
        let cancelled = false;
        const actualizar = (parcial) => {
            if (!cancelled) setEstado((prev) => ({ ...prev, ...parcial }));
        };

        const cargar = async () => {
            try {
                const respuesta = await deliveryService.getRutaMostrador();
                if (!hayRuta(respuesta)) return actualizar({ cargando: false });
                const resultado = await cargarTransportista(respuesta);
                return actualizar({ rutaMostrador: respuesta, cargando: false, ...resultado });
            } catch (err) {
                console.error("Error obteniendo ruta de mostrador:", err);
                return actualizar({ cargando: false, error: ERROR_RUTA });
            }
        };

        cargar();
        return () => {
            cancelled = true;
        };
    }, []);

    return estado;
};
